import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mySpacesNumberPipe' })
export class SpacesNumberPipe implements PipeTransform {
  public transform(value: any): any {
    // we remove all spaces
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
